import React from 'react';
import { Box, Flex, theme } from '@xometry/xometry_loft';
import { Cell } from 'react-table';

export const PendingMemberColumns = () => {
  return [
    {
      Header: () => <Box>Email</Box>,
      accessor: 'userData',
      Cell: ({ cell }: { cell: Cell }) => (
        <Flex>
          <Box
            marginRight="10px"
            fontSize="28px"
            color={theme.colors.darkBlues[100]}
          >
            <i className="fat fa-user-circle" />
          </Box>
          <Box lineHeight="30px">{cell.value.email}</Box>
        </Flex>
      ),
    },
    {
      Header: () => <Box>Date Added</Box>,
      accessor: 'date',
    },
    {
      Header: () => <Flex>Role</Flex>,
      accessor: 'role',
      Cell: ({ cell }: { cell: Cell }) => <Flex>{cell.value}</Flex>,
    },
  ];
};
